import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../store';

const initialState: { enabled: boolean; message: string } = {
  enabled: true,
  message: ''
};

export const powerManagementSettingsSlice = createSlice({
  name: 'powerManagementSettings',
  initialState,
  reducers: {
    toggleEnabled: (state) => {
      state.enabled = !state.enabled;
    },
    setMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
    }
  }
});

export const { toggleEnabled, setMessage } = powerManagementSettingsSlice.actions;

export const getSettings = (state: RootState) => {
  return state.powerManagementSettings
};

export const setTemporaryMessage = (message: string): AppThunk => async dispatch => {
  dispatch(setMessage(message));
  
  setTimeout(() => { dispatch(setMessage('')) }, 5000);
};

export default powerManagementSettingsSlice.reducer;
